import { styled } from "@/styled-system/jsx";

export const StyledErrorPageWrapper = styled("div", {
  base: {
    display: "flex",
    gap: "15px",
    flexDirection: "column",
    margin: "15px",
  },
});
